import type { AdminItem } from './contentApi.js';

/**
 * De quem é esta ficha — e, por isso, o que a próxima reimportação faz com ela.
 *
 * A semeadura do acervo (`make seed-content`, e toda importação de jogo) só
 * atualiza o que ninguém mexeu. Editada no painel, a ficha fica como está;
 * criada no painel, nunca é tocada. Ver `ContentSeeder` e ARQUITETURA §5.
 */
export function ContentOrigin({ item }: { readonly item: AdminItem }): JSX.Element {
  if (item.isCustom) {
    return <span className="admin-status-pill custom" title="Criado no painel: a reimportação nunca o toca.">Criado no painel</span>;
  }
  if (item.isEdited) {
    return (
      <span className="admin-status-pill edited" title="Veio do acervo e foi editado aqui: a reimportação não o sobrescreve mais.">
        Acervo · editado no painel
      </span>
    );
  }
  return (
    <span className="admin-status-pill core" title="Veio do acervo e ninguém editou: a reimportação o atualiza.">
      Acervo · acompanha a reimportação
    </span>
  );
}
